/**
 * Do not edit directly
 * Generated on Wed, 25 May 2022 20:20:54 GMT
 */

module.exports = {
  "borderRadius": {
    "1xsmall": "4px",
    "small": "8px",
    "medium": "12px",
    "large": "24px",
    "pill": "10rem",
    "circle": "50%"
  },
  "breakpoints": {
    "1xsmall": "320px",
    "small": "720px",
    "medium": "1080px",
    "large": "1280px",
    "1xlarge": "1600px"
  },
  "color": {
    "primary": {
      "softer": "#e6eeff",
      "soft": "#7da2ff",
      "base": "#0c29d0",
      "strong": "#0a1f9c",
      "stronger": "#0b134a"
    },
    "accent": {
      "softer": "#c9ffee",
      "soft": "#0dc78b",
      "base": "#00865b",
      "strong": "#086a4c",
      "stronger": "#054933"
    },
    "informative": {
      "softer": "#f3deff",
      "soft": "#cb6dfd",
      "base": "#6a00a3",
      "strong": "#460469",
      "stronger": "#360252"
    },
    "alert": {
      "softer": "#ffeae5",
      "soft": "#fb775c",
      "base": "#d23718",
      "strong": "#ab351d",
      "stronger": "#6e0000"
    },
    "notice": {
      "softer": "#fff3d1",
      "soft": "#ffce4b",
      "base": "#dda100",
      "strong": "#956e07",
      "stronger": "#6e5001"
    },
    "success": {
      "softer": "#c9ffee",
      "soft": "#0dc78b",
      "base": "#00865b",
      "strong": "#086a4c",
      "stronger": "#054933"
    },
    "neutral": {
      "softest": "#ffffff",
      "softer": "#f3f3fc",
      "soft": "#d1d1e3",
      "base": "#696d8c",
      "strong": "#50557c",
      "stronger": "#312f4f"
    }
  },
  "fontFamily": {
    "brand": "soleil"
  },
  "fontSize": {
    "2xmini": "11px",
    "1xmini": "12px",
    "mini": "13px",
    "3xsmall": "14px",
    "2xsmall": "15px",
    "1xsmall": "16px",
    "small": "17px",
    "medium": "18px",
    "large": "20px",
    "1xlarge": "22px",
    "2xlarge": "24px",
    "3xlarge": "26px",
    "huge": "28px",
    "1xhuge": "32px",
    "2xhuge": "40px"
  },
  "fontWeight": {
    "regular": "400",
    "bold": "600"
  },
  "graphicAndData": {
    "color": {
      "brand1": {
        "softest": "#e6eeff",
        "softer": "#abc6ff",
        "soft": "#364ef7",
        "base": "#0c29d0",
        "strong": "#0a1f9c",
        "stronger": "#0b134a"
      },
      "brand2": {
        "softest": "#c9ffee",
        "softer": "#93f3d4",
        "soft": "#0fe39f",
        "base": "#0dc78b",
        "strong": "#00865b",
        "stronger": "#086a4c"
      },
      "brand3": {
        "softest": "#f3deff",
        "softer": "#dea5fc",
        "soft": "#9905e8",
        "base": "#6a00a3",
        "strong": "#460469",
        "stronger": "#360252"
      },
      "brand4": {
        "softest": "#ffeae5",
        "softer": "#ff9a86",
        "soft": "#fb775c",
        "base": "#e64c2d",
        "strong": "#d23718",
        "stronger": "#ab351d"
      },
      "brand5": {
        "softest": "#fff3d1",
        "softer": "#ffe49b",
        "soft": "#f7bc1c",
        "base": "#edad00",
        "strong": "#dda100",
        "stronger": "#956e07"
      }
    }
  },
  "letterSpacing": {
    "tight": "0px",
    "loose": "2px"
  },
  "lineHeight": {
    "3xsmall": "12px",
    "2xsmall": "16px",
    "1xsmall": "20px",
    "small": "24px",
    "medium": "28px",
    "large": "32px",
    "1xlarge": "36px",
    "2xlarge": "40px",
    "3xlarge": "44px",
    "huge": "48px",
    "1xhuge": "52px",
    "2xhuge": "56px"
  },
  "opacity": {
    "base": "0.4",
    "strong": "0.8"
  },
  "shadow": {
    "low": "0px 2px 4px rgba(11, 19, 74, 0.08), 0px 4px 8px rgba(11, 19, 74, 0.06), 0px 8px 16px rgba(11, 19, 74, 0.04)",
    "high": "0px 4px 8px rgba(11, 19, 74, 0.1), 0px 8px 16px rgba(11, 19, 74, 0.08), 0px 16px 32px rgba(11, 19, 74, 0.06)",
    "higher": "0px 8px 16px rgba(11, 19, 74, 0.1), 0px 16px 32px rgba(11, 19, 74, 0.08), 0px 32px 64px rgba(11, 19, 74, 0.06)",
    "diffuse": "0px 0px 16px rgba(11, 19, 74, 0.1), 0px 0px 32px rgba(11, 19, 74, 0.08), 0px 0px 64px rgba(11, 19, 74, 0.06)"
  },
  "spacing": {
    "inline": {
      "none": "0px",
      "3xsmall": "4px",
      "2xsmall": "8px",
      "1xsmall": "12px",
      "small": "16px",
      "medium": "24px",
      "large": "32px",
      "1xlarge": "40px"
    },
    "inset": {
      "2xsmall": "4px",
      "1xsmall": "8px",
      "small": "16px",
      "medium": "24px",
      "large": "32px",
      "1xlarge": "40px",
      "2xlarge": "48px"
    },
    "squishedInset": {
      "1xsmall": "4px 8px",
      "small": "8px 16px",
      "medium": "12px 24px",
      "large": "16px 32px",
      "1xlarge": "24px 48px"
    },
    "stack": {
      "none": "0px",
      "2xsmall": "4px",
      "1xsmall": "8px",
      "small": "16px",
      "medium": "24px",
      "large": "32px",
      "1xlarge": "40px",
      "2xlarge": "48px",
      "3xlarge": "56px",
      "huge": "64px"
    },
    "stretchedInset": {
      "1xsmall": "8px 4px",
      "small": "16px 8px",
      "medium": "24px 12px",
      "large": "32px 16px",
      "1xlarge": "48px 24px"
    }
  },
  "components": {
    "badge": {
      "padding": "4px 8px",
      "font-family": "soleil",
      "font-size": "12px",
      "line-height": "16px",
      "font-weight": "600",
      "radius": {
        "default": "4px",
        "pill": "10rem"
      },
      "variation": {
        "primary": {
          "background": "#e6eeff",
          "color": "#0b134a"
        },
        "info": {
          "background": "#f3deff",
          "color": "#360252"
        }
      }
    },
    "button": {
      "default": {
        "font-family": "soleil",
        "font-weight": "600",
        "size": {
          "medium": {
            "padding": "12px 24px",
            "font-size": "16px",
            "line-height": "24px",
            "icon-position": "12px"
          },
          "small": {
            "padding": "8px 16px",
            "font-size": "14px",
            "line-height": "20px",
            "icon-position": "8px"
          }
        },
        "radius": "8px",
        "box-shadow": "0px 2px 4px rgba(11, 19, 74, 0.08), 0px 4px 8px rgba(11, 19, 74, 0.06), 0px 8px 16px rgba(11, 19, 74, 0.04)",
        "styles": {
          "primary": {
            "rest": {
              "background-color": "#0c29d0",
              "color": "#ffffff",
              "border-width": "",
              "border-style": "",
              "border-color": ""
            },
            "hover": {
              "background-color": "#0a1f9c",
              "color": "#ffffff",
              "border-width": "",
              "border-style": "",
              "border-color": ""
            },
            "active": {
              "background-color": "#0b134a",
              "color": "#ffffff",
              "border-width": "",
              "border-style": "",
              "border-color": ""
            }
          },
          "accent": {
            "rest": {
              "background-color": "#00865b",
              "color": "#ffffff",
              "border-width": "",
              "border-style": "",
              "border-color": ""
            },
            "hover": {
              "background-color": "#086a4c",
              "color": "#ffffff",
              "border-width": "",
              "border-style": "",
              "border-color": ""
            },
            "active": {
              "background-color": "#054933",
              "color": "#ffffff",
              "border-width": "",
              "border-style": "",
              "border-color": ""
            }
          },
          "secondary": {
            "rest": {
              "background-color": "#ffffff",
              "color": "#312f4f",
              "border-width": "1px",
              "border-style": "solid",
              "border-color": "#d1d1e3"
            },
            "hover": {
              "background-color": "#f3f3fc",
              "color": "#312f4f",
              "border-width": "1px",
              "border-style": "solid",
              "border-color": "#d1d1e3"
            },
            "active": {
              "background-color": "#d1d1e3",
              "color": "#312f4f",
              "border-width": "1px",
              "border-style": "solid",
              "border-color": "#d1d1e3"
            }
          },
          "danger": {
            "rest": {
              "background-color": "#ffffff",
              "color": "#d23718",
              "border-width": "1px",
              "border-style": "solid",
              "border-color": "#fb775c"
            },
            "hover": {
              "background-color": "#ffeae5",
              "color": "#ab351d",
              "border-width": "1px",
              "border-style": "solid",
              "border-color": "#fb775c"
            },
            "active": {
              "background-color": "#fb775c",
              "color": "#6e0000",
              "border-width": "1px",
              "border-style": "solid",
              "border-color": "#fb775c"
            }
          }
        },
        "disabled": {
          "opacity": "0.4"
        }
      },
      "icon": {
        "size": {
          "height": "48px",
          "width": "48px"
        },
        "radius": "50%",
        "styles": {
          "primary": {
            "rest": {
              "background-color": "#ffffff",
              "color": "#0c29d0"
            },
            "hover": {
              "background-color": "#f3f3fc",
              "color": "#0c29d0"
            },
            "active": {
              "background-color": "#d1d1e3",
              "color": "#0c29d0"
            }
          },
          "secondary": {
            "rest": {
              "background-color": "#ffffff",
              "color": "#312f4f"
            },
            "hover": {
              "background-color": "#f3f3fc",
              "color": "#312f4f"
            },
            "active": {
              "background-color": "#d1d1e3",
              "color": "#312f4f"
            }
          }
        }
      }
    },
    "grid": {
      "container": {
        "max-width": "1440px",
        "margin": {
          "xsmall": "16px",
          "small": "32px",
          "medium": "48px",
          "large": "80px",
          "xlarge": "auto"
        }
      },
      "gutter": {
        "small": "16px",
        "medium": "24px"
      }
    },
    "input": {
      "padding": "12px",
      "margin": "8px",
      "helper-text": {
        "color": "#50557c"
      },
      "border-color": "#d1d1e3",
      "font-family": "soleil",
      "line-height": "24px",
      "color": "#696d8c",
      "radius": "8px",
      "disabled": {
        "background": "#f3f3fc",
        "border-color": "#f3f3fc"
      },
      "focused": {
        "border-color": "#0c29d0"
      },
      "feedback": {
        "error": {
          "border-color": "#d23718"
        }
      },
      "readonly": {
        "background": "#f3f3fc",
        "color": "#312f4f"
      },
      "suprefix": {
        "margin": "12px",
        "color": "#50557c",
        "paragraph": {
          "color": "#696d8c",
          "line-height": "24px",
          "font-size": "15px"
        },
        "feedback-icon": {
          "margin-left": "12px",
          "error": {
            "color": "#d23718"
          },
          "valid": {
            "color": "#00865b"
          }
        }
      }
    },
    "link": {
      "font-family": "soleil",
      "line-height": "24px",
      "font-weight": "600",
      "font-size": {
        "medium": "16px",
        "large": "18px"
      },
      "radius": "4px",
      "icon": {
        "size": "24px",
        "margin": "12px"
      },
      "colors": {
        "rest": "#0c29d0",
        "hover": "#0a1f9c",
        "focus": "#0a1f9c",
        "active": "#0b134a",
        "visited": "#360252"
      }
    },
    "modal": {
      "overlay": {
        "background-color": "#312f4f",
        "opacity": "0.4"
      },
      "dialog": {
        "size": {
          "large": {
            "max-width": "864px"
          },
          "small": {
            "max-width": "576px"
          }
        },
        "padding": "32px",
        "margin": "16px",
        "radius": "24px",
        "box-shadow": "0px 8px 16px rgba(11, 19, 74, 0.1), 0px 16px 32px rgba(11, 19, 74, 0.08), 0px 32px 64px rgba(11, 19, 74, 0.06)",
        "background-color": "#ffffff"
      },
      "close": {
        "top": "16px",
        "right": "16px"
      },
      "header": {
        "margin-top": "24px"
      },
      "body": {
        "desktop": {
          "margin-top": "24px",
          "margin-bottom": "32px"
        },
        "mobile": {
          "margin-top": "16px",
          "margin-bottom": "24px"
        }
      }
    },
    "table": {
      "desktop": {
        "radius": "12px",
        "border-width": "1px",
        "border-color": "#d1d1e3",
        "column": {
          "min-width": "120px"
        },
        "heading": {
          "padding": "8px 16px",
          "font-size": "14px",
          "font-weight": "600",
          "line-height": "24px",
          "color": "#312f4f"
        },
        "cell": {
          "font-size": "16px",
          "font-weight": "400",
          "line-height": "24px",
          "color": "#50557c",
          "padding": "8px 16px"
        },
        "detailedContentCell": {
          "padding": "4px 8px"
        },
        "detailedContent": {
          "padding": "12px 24px"
        }
      },
      "mobile": {
        "radius": "12px",
        "border-width": "1px",
        "border-color": "#d1d1e3",
        "cell": {
          "margin-bottom": "16px",
          "color": "#50557c"
        },
        "heading": {
          "margin-bottom": "4px"
        },
        "card": {
          "padding": "8px 16px 16px"
        },
        "detailedContent": {
          "padding-top": "16px"
        }
      }
    },
    "text": {
      "color": "#312f4f",
      "bold": "600",
      "title": {
        "large": {
          "desktop": {
            "fontSize": "40px",
            "lineHeight": "56px",
            "fontWeight": "600",
            "letterSpacing": "0px"
          },
          "mobile": {
            "fontSize": "28px",
            "lineHeight": "36px",
            "fontWeight": "600",
            "letterSpacing": "0px"
          }
        },
        "default": {
          "desktop": {
            "fontSize": "26px",
            "lineHeight": "36px",
            "fontWeight": "600",
            "letterSpacing": "0px"
          },
          "mobile": {
            "fontSize": "20px",
            "lineHeight": "28px",
            "fontWeight": "600",
            "letterSpacing": "0px"
          }
        }
      },
      "sectionHeading": {
        "large": {
          "desktop": {
            "fontSize": "32px",
            "lineHeight": "44px",
            "fontWeight": "600",
            "letterSpacing": "0px"
          },
          "mobile": {
            "fontSize": "24px",
            "lineHeight": "32px",
            "fontWeight": "600",
            "letterSpacing": "0px"
          }
        },
        "default": {
          "desktop": {
            "fontSize": "24px",
            "lineHeight": "32px",
            "fontWeight": "600",
            "letterSpacing": "0px"
          },
          "mobile": {
            "fontSize": "18px",
            "lineHeight": "24px",
            "fontWeight": "600",
            "letterSpacing": "0px"
          }
        }
      },
      "sectionSubheading": {
        "large": {
          "desktop": {
            "fontSize": "26px",
            "lineHeight": "36px",
            "fontWeight": "600",
            "letterSpacing": "0px"
          },
          "mobile": {
            "fontSize": "22px",
            "lineHeight": "28px",
            "fontWeight": "600",
            "letterSpacing": "0px"
          }
        },
        "default": {
          "desktop": {
            "fontSize": "22px",
            "lineHeight": "28px",
            "fontWeight": "600",
            "letterSpacing": "0px"
          },
          "mobile": {
            "fontSize": "16px",
            "lineHeight": "20px",
            "fontWeight": "600",
            "letterSpacing": "0px"
          }
        }
      },
      "detailedSubheading": {
        "large": {
          "desktop": {
            "fontSize": "22px",
            "lineHeight": "28px",
            "fontWeight": "600",
            "letterSpacing": "0px"
          },
          "mobile": {
            "fontSize": "20px",
            "lineHeight": "24px",
            "fontWeight": "600",
            "letterSpacing": "0px"
          }
        },
        "default": {
          "desktop": {
            "fontSize": "20px",
            "lineHeight": "28px",
            "fontWeight": "600",
            "letterSpacing": "0px"
          },
          "mobile": {
            "fontSize": "14px",
            "lineHeight": "20px",
            "fontWeight": "600",
            "letterSpacing": "0px"
          }
        }
      },
      "paragraphLg": {
        "large": {
          "desktop": {
            "fontSize": "24px",
            "lineHeight": "36px",
            "fontWeight": "400",
            "letterSpacing": "0px"
          },
          "mobile": {
            "fontSize": "20px",
            "lineHeight": "28px",
            "fontWeight": "400",
            "letterSpacing": "0px"
          }
        },
        "default": {
          "desktop": {
            "fontSize": "18px",
            "lineHeight": "28px",
            "fontWeight": "400",
            "letterSpacing": "0px"
          },
          "mobile": {
            "fontSize": "17px",
            "lineHeight": "24px",
            "fontWeight": "400",
            "letterSpacing": "0px"
          }
        }
      },
      "paragraphMd": {
        "large": {
          "desktop": {
            "fontSize": "18px",
            "lineHeight": "28px",
            "fontWeight": "400",
            "letterSpacing": "0px"
          },
          "mobile": {
            "fontSize": "18px",
            "lineHeight": "28px",
            "fontWeight": "400",
            "letterSpacing": "0px"
          }
        },
        "default": {
          "desktop": {
            "fontSize": "16px",
            "lineHeight": "24px",
            "fontWeight": "400",
            "letterSpacing": "0px"
          },
          "mobile": {
            "fontSize": "15px",
            "lineHeight": "20px",
            "fontWeight": "400",
            "letterSpacing": "0px"
          }
        }
      },
      "caption": {
        "large": {
          "desktop": {
            "fontSize": "16px",
            "lineHeight": "24px",
            "fontWeight": "400",
            "letterSpacing": "0px"
          },
          "mobile": {
            "fontSize": "16px",
            "lineHeight": "24px",
            "fontWeight": "400",
            "letterSpacing": "0px"
          }
        },
        "default": {
          "desktop": {
            "fontSize": "14px",
            "lineHeight": "24px",
            "fontWeight": "400",
            "letterSpacing": "0px"
          },
          "mobile": {
            "fontSize": "13px",
            "lineHeight": "20px",
            "fontWeight": "400",
            "letterSpacing": "0px"
          }
        }
      },
      "overlineLg": {
        "large": {
          "desktop": {
            "fontSize": "22px",
            "lineHeight": "32px",
            "fontWeight": "400",
            "letterSpacing": "2px"
          },
          "mobile": {
            "fontSize": "22px",
            "lineHeight": "32px",
            "fontWeight": "400",
            "letterSpacing": "2px"
          }
        },
        "default": {
          "desktop": {
            "fontSize": "16px",
            "lineHeight": "24px",
            "fontWeight": "400",
            "letterSpacing": "2px"
          },
          "mobile": {
            "fontSize": "16px",
            "lineHeight": "24px",
            "fontWeight": "400",
            "letterSpacing": "2px"
          }
        }
      },
      "overlineMd": {
        "large": {
          "desktop": {
            "fontSize": "16px",
            "lineHeight": "24px",
            "fontWeight": "400",
            "letterSpacing": "2px"
          },
          "mobile": {
            "fontSize": "18px",
            "lineHeight": "28px",
            "fontWeight": "400",
            "letterSpacing": "2px"
          }
        },
        "default": {
          "desktop": {
            "fontSize": "14px",
            "lineHeight": "20px",
            "fontWeight": "400",
            "letterSpacing": "2px"
          },
          "mobile": {
            "fontSize": "14px",
            "lineHeight": "20px",
            "fontWeight": "400",
            "letterSpacing": "2px"
          }
        }
      }
    }
  }
};